import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtCommodityShippedGridService } from './rt-commodity-shipped-grid.service';
import { RtCommodityShippedDetailsComponent } from './rt-commodity-shipped-details/rt-commodity-shipped-details.component';
import { TripCommodityShippedComponent } from '../railtrac-trip/rt-trip-commodity-shipped/trip-commodity-shipped/trip-commodity-shipped.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BourqueCoreModule } from '@bds/core';
import { BdsDateTimePickerModule } from '@bds/smart-components';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RailtracTripModule } from '../railtrac-trip/railtrac-trip.module';
import { BdsCommodityModule } from '@bds/commodity';

@NgModule({
    declarations: [RtCommodityShippedDetailsComponent, TripCommodityShippedComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BourqueCoreModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        BdsDateTimePickerModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatTableModule,
        FontAwesomeModule,
        MatToolbarModule,
        BdsCommodityModule,
    ],
    exports: [RtCommodityShippedDetailsComponent, TripCommodityShippedComponent],
    providers: [RtCommodityShippedGridService],
})
export class RtCommodityShippedModule {}
